import NotificationsPanelItem from './NotificationsPanelItem'

export default NotificationsPanelItem
